import { isNil } from 'lodash';

import config from '../config';

function getUsernameAndClient(username) {
  if (config.env === 'development') {
    return {
      name: 'TestUser',
      client: 'TestClient',
    }
  }

  if (username) {
    const [name, client] = username.split('@');
    return {
      name,
      client: !client ? 'iAuditTest' : client,
    };
  }

  return {
    name: '',
    client: '',
  }
}

function getSessionUsername(username) {
  if (config.env === 'development') {
    return true;
  }

  // eslint-disable-next-line no-unused-vars
  const {name, client} = getUsernameAndClient(username);

  return name || 'None';
}

function canAccessGlobalAdminStats(username) {
   if (config.env === 'development') {
    return true;
  }

  const {name, client} = getUsernameAndClient(username);
  const allowedUsers = ['nmutic', 'bvidas', 'neno'];
  const isAllowedName = allowedUsers.includes(name);

  if (isAllowedName && isNil(client)) {
    return true;
  }

  if (isAllowedName && client === 'iAuditTest') {
    return true;
  }

  return false;
}

export default {
    getSessionUsername,
    getUsernameAndClient,
    canAccessGlobalAdminStats,
};
